import { extendTheme } from '@chakra-ui/react'

export const theme = extendTheme({
  fonts: {
    heading: "'Cormorant Garamond', Georgia, serif",
    body: "'Inter', system-ui, sans-serif",
  },
  colors: {
    plum: {
      50: '#f6f2f8',
      100: '#e7dcee',
      200: '#cdb5dc',
      300: '#a983c1',
      400: '#8757a4',
      500: '#6b3d87',
      600: '#552d6d',
      700: '#3f2153',
      800: '#2a1638',
      900: '#170c20',
      950: '#0d0613',
    },
    gold: {
      50: '#fdf9ef',
      100: '#f8eed2',
      200: '#efd89b',
      300: '#e4c072',
      400: '#d4a556',
      500: '#c08b3c',
      600: '#9c6d2c',
      700: '#77521f',
    },
    cream: {
      50: '#fdfbf7',
      100: '#f8f4ec',
      200: '#efe7d9',
    },
  },
  styles: {
    global: {
      'html, body': {
        bg: 'cream.50',
        color: 'plum.900',
        fontSize: { base: '16px', md: '17px' },
        lineHeight: 1.7,
      },
      '#root': {
        width: '100%',
      },
      ':focus-visible': {
        outline: '2px solid',
        outlineColor: 'gold.500',
        outlineOffset: '2px',
      },
    },
  },
  components: {
    Heading: {
      baseStyle: {
        fontWeight: 600,
        letterSpacing: '0.01em',
        lineHeight: 1.2,
      },
    },
    Button: {
      baseStyle: {
        fontFamily: "'Inter', sans-serif",
        fontWeight: 600,
        letterSpacing: '0.06em',
        borderRadius: 'full',
      },
      variants: {
        whatsapp: {
          bg: '#1f9d55',
          color: 'white',
          _hover: { bg: '#18803f', textDecoration: 'none' },
          _active: { bg: '#146433' },
        },
        goldSolid: {
          bg: 'gold.300',
          color: 'plum.900',
          _hover: { bg: 'gold.200', textDecoration: 'none' },
          _active: { bg: 'gold.400' },
        },
        goldOutline: {
          bg: 'transparent',
          color: 'gold.200',
          border: '1px solid',
          borderColor: 'gold.300',
          _hover: { bg: 'whiteAlpha.200', textDecoration: 'none' },
        },
        plumOutline: {
          bg: 'transparent',
          color: 'plum.700',
          border: '1px solid',
          borderColor: 'plum.300',
          _hover: { bg: 'plum.50', textDecoration: 'none' },
        },
      },
    },
  },
})
